export const AFFILIATE_PROFILE_SETTINGS_PAYMENT_SYSTEMS_ROUTE_NAME = Symbol('affiliate.profile-settings.payment-systems');

export const PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_URL = 'confirmation';
export const PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_MUTATION_KEY = 'profile-settings.confirmation-email.save';
